import React from 'react';
import './blogArticle.scss';
import Image from 'next/image';
import Link from 'next/link';
import { urlForImage } from '@/sanity/lib/utils';
import { GetRecentBlogPostResult } from '@/sanity.types';

interface BlogComponentProps {
  src:
    | NonNullable<GetRecentBlogPostResult[0]['coverMedia']>['coverImage']
    | null;
  alt: string;
  blogTitle: string;
  resource?: boolean;
  resourceCategory?: string;
  hrefCategorySlug?: string;
  href: string;
  blurDataURL?: string;
  priority?: boolean;
}
export default function BlogArticle({
  src,
  alt,
  blogTitle,
  resource,
  resourceCategory,
  hrefCategorySlug,
  href,
  blurDataURL,
  priority = false,
}: BlogComponentProps) {
  return (
    <div className="blogArticleCard">
      <Link href={href} aria-label={`Read more about ${blogTitle}`}>
        <Image
          src={
            (src && (urlForImage(src)?.url() as string)) ||
            '/n_images/default-blog.jpg'
          }
          alt={alt || 'Blog article image'}
          width={300}
          height={250}
          quality={100}
          sizes="(max-width: 767px) 100vw, 30vw"
          role="img"
          placeholder="blur"
          blurDataURL={blurDataURL}
          priority={priority}
        />
      </Link>
      {resource && hrefCategorySlug ? (
        <div className="resourceCate">
          <Link
            href={hrefCategorySlug}
            aria-label={`Category: ${resourceCategory}`}
          >
            {resourceCategory}
          </Link>
        </div>
      ) : (
        <></>
      )}
      <Link href={href} aria-label={`Read blog post: ${blogTitle}`}>
        <h3>{blogTitle}</h3>
      </Link>
    </div>
  );
}
